/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../app/katiso.module';
import * as i2 from '../../app/components/main/main.component';
import * as i3 from '../../$$_gendir/node_modules/ng2-toastr/src/toast-container.component.ngfactory';
import * as i4 from './components/home/home.component.ngfactory';
import * as i5 from './components/errors/errors.component.ngfactory';
import * as i6 from './components/about-us/about-us.component.ngfactory';
import * as i7 from './components/services/services.component.ngfactory';
import * as i8 from './components/services/automation/automation.component.ngfactory';
import * as i9 from './components/services/programming/programming.component.ngfactory';
import * as i10 from './components/services/engineering/engineering.component.ngfactory';
import * as i11 from './components/contact-us/contact-us.component.ngfactory';
import * as i12 from './components/main/main.component.ngfactory';
import * as i13 from '@angular/common';
import * as i14 from '@angular/forms';
import * as i15 from '@angular/platform-browser';
import * as i16 from '@angular/animations/browser';
import * as i17 from '@angular/platform-browser/animations';
import * as i18 from '@angular/animations';
import * as i19 from '@angular/http';
import * as i20 from 'ng2-toastr/src/toast-options';
import * as i21 from 'ng2-toastr/src/toast-manager';
import * as i22 from '@angular/router';
import * as i23 from 'ng2share/share.module';
import * as i24 from 'ng2-toastr/src/toast.module';
import * as i25 from '../../app/components/home/home.component';
import * as i26 from '../../app/components/errors/errors.component';
import * as i27 from '../../app/components/about-us/about-us.component';
import * as i28 from '../../app/components/services/services.component';
import * as i29 from '../../app/components/services/automation/automation.component';
import * as i30 from '../../app/components/services/programming/programming.component';
import * as i31 from '../../app/components/services/engineering/engineering.component';
import * as i32 from '../../app/components/contact-us/contact-us.component';
export const KatisoModuleNgFactory:i0.NgModuleFactory<i1.KatisoModule> = i0.ɵcmf(i1.KatisoModule,
    [i2.MainComponent],(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i3.ToastContainerNgFactory,i4.HomeComponentNgFactory,i5.ErrorsComponentNgFactory,
              i6.AboutUsComponentNgFactory,i7.ServicesComponentNgFactory,i8.AutomationComponentNgFactory,
              i9.ProgrammingComponentNgFactory,i10.EngineeringComponentNgFactory,i11.ContactUsComponentNgFactory,
              i12.MainComponentNgFactory]],[3,i0.ComponentFactoryResolver],i0.NgModuleRef]),
          i0.ɵmpd(5120,i0.LOCALE_ID,i0.ɵm,[[3,i0.LOCALE_ID]]),i0.ɵmpd(4608,i13.NgLocalization,
              i13.NgLocaleLocalization,[i0.LOCALE_ID]),i0.ɵmpd(4608,i14.ɵi,i14.ɵi,
              ([] as any[])),i0.ɵmpd(5120,i0.APP_ID,i0.ɵf,([] as any[])),i0.ɵmpd(5120,
              i0.IterableDiffers,i0.ɵk,([] as any[])),i0.ɵmpd(5120,i0.KeyValueDiffers,
              i0.ɵl,([] as any[])),i0.ɵmpd(4608,i15.DomSanitizer,i15.ɵe,[i13.DOCUMENT]),
          i0.ɵmpd(6144,i0.Sanitizer,(null as any),[i15.DomSanitizer]),i0.ɵmpd(4608,
              i15.HAMMER_GESTURE_CONFIG,i15.HammerGestureConfig,([] as any[])),i0.ɵmpd(5120,
              i15.EVENT_MANAGER_PLUGINS,(p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
                return [new i15.ɵDomEventsPlugin(p0_0),new i15.ɵKeyEventsPlugin(p1_0),
                    new i15.ɵHammerGesturesPlugin(p2_0,p2_1)];
              },[i13.DOCUMENT,i13.DOCUMENT,i13.DOCUMENT,i15.HAMMER_GESTURE_CONFIG]),
          i0.ɵmpd(4608,i15.EventManager,i15.EventManager,[i15.EVENT_MANAGER_PLUGINS,
              i0.NgZone]),i0.ɵmpd(135680,i15.ɵDomSharedStylesHost,i15.ɵDomSharedStylesHost,
              [i13.DOCUMENT]),i0.ɵmpd(4608,i15.ɵDomRendererFactory2,i15.ɵDomRendererFactory2,
              [i15.EventManager,i15.ɵDomSharedStylesHost]),i0.ɵmpd(5120,i16.AnimationDriver,
              i17.ɵc,([] as any[])),i0.ɵmpd(5120,i16.ɵAnimationStyleNormalizer,i17.ɵd,
              ([] as any[])),i0.ɵmpd(4608,i16.ɵAnimationEngine,i17.ɵb,[i16.AnimationDriver,
              i16.ɵAnimationStyleNormalizer]),i0.ɵmpd(5120,i0.RendererFactory2,i17.ɵe,
              [i15.ɵDomRendererFactory2,i16.ɵAnimationEngine,i0.NgZone]),i0.ɵmpd(6144,
              i15.ɵSharedStylesHost,(null as any),[i15.ɵDomSharedStylesHost]),i0.ɵmpd(4608,
              i0.Testability,i0.Testability,[i0.NgZone]),i0.ɵmpd(4608,i15.Meta,i15.Meta,
              [i13.DOCUMENT]),i0.ɵmpd(4608,i15.Title,i15.Title,[i13.DOCUMENT]),i0.ɵmpd(4608,
              i18.AnimationBuilder,i17.ɵBrowserAnimationBuilder,[i0.RendererFactory2,
                  i15.DOCUMENT]),i0.ɵmpd(4608,i19.BrowserXhr,i19.BrowserXhr,([] as any[])),
          i0.ɵmpd(4608,i19.ResponseOptions,i19.BaseResponseOptions,([] as any[])),
          i0.ɵmpd(5120,i19.XSRFStrategy,i19.ɵb,([] as any[])),i0.ɵmpd(4608,i19.XHRBackend,
              i19.XHRBackend,[i19.BrowserXhr,i19.ResponseOptions,i19.XSRFStrategy]),
          i0.ɵmpd(4608,i19.RequestOptions,i19.BaseRequestOptions,([] as any[])),i0.ɵmpd(5120,
              i19.Http,i19.ɵc,[i19.XHRBackend,i19.RequestOptions]),i0.ɵmpd(4608,i20.ToastOptions,
              i20.ToastOptions,([] as any[])),i0.ɵmpd(4608,i21.ToastsManager,i21.ToastsManager,
              [i0.ComponentFactoryResolver,i0.NgZone,i0.ApplicationRef,i20.ToastOptions]),
          i0.ɵmpd(5120,i22.ActivatedRoute,i22.ɵf,[i22.Router]),i0.ɵmpd(4608,i22.NoPreloading,
              i22.NoPreloading,([] as any[])),i0.ɵmpd(6144,i22.PreloadingStrategy,
              (null as any),[i22.NoPreloading]),i0.ɵmpd(135680,i22.RouterPreloader,
              i22.RouterPreloader,[i22.Router,i0.NgModuleFactoryLoader,i0.Compiler,
                  i0.Injector,i22.PreloadingStrategy]),i0.ɵmpd(4608,i22.PreloadAllModules,
              i22.PreloadAllModules,([] as any[])),i0.ɵmpd(5120,i22.ROUTER_INITIALIZER,
              i22.ɵi,[i22.ɵg]),i0.ɵmpd(5120,i0.APP_BOOTSTRAP_LISTENER,(p0_0:any) => {
            return [p0_0];
          },[i22.ROUTER_INITIALIZER]),i0.ɵmpd(512,i13.CommonModule,i13.CommonModule,
              ([] as any[])),i0.ɵmpd(512,i14.ɵba,i14.ɵba,([] as any[])),i0.ɵmpd(512,
              i14.FormsModule,i14.FormsModule,([] as any[])),i0.ɵmpd(512,i23.ShareModule,
              i23.ShareModule,([] as any[])),i0.ɵmpd(1024,i0.ErrorHandler,i15.ɵa,([] as any[])),
          i0.ɵmpd(1024,i0.NgProbeToken,() => {
            return [i22.ɵb()];
          },([] as any[])),i0.ɵmpd(512,i22.ɵg,i22.ɵg,[i0.Injector]),i0.ɵmpd(1024,i0.APP_INITIALIZER,
              (p0_0:any,p0_1:any,p1_0:any) => {
                return [i15.ɵc(p0_0,p0_1),i22.ɵh(p1_0)];
              },[[2,i15.NgProbeToken],[2,i0.NgProbeToken],i22.ɵg]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,[i0.ApplicationRef]),
          i0.ɵmpd(512,i15.BrowserModule,i15.BrowserModule,[[3,i15.BrowserModule]]),
          i0.ɵmpd(512,i17.BrowserAnimationsModule,i17.BrowserAnimationsModule,([] as any[])),
          i0.ɵmpd(512,i19.HttpModule,i19.HttpModule,([] as any[])),i0.ɵmpd(512,i24.ToastModule,
              i24.ToastModule,([] as any[])),i0.ɵmpd(1024,i22.ɵa,i22.ɵd,[[3,i22.Router]]),
          i0.ɵmpd(512,i22.UrlSerializer,i22.DefaultUrlSerializer,([] as any[])),i0.ɵmpd(512,
              i22.ChildrenOutletContexts,i22.ChildrenOutletContexts,([] as any[])),
          i0.ɵmpd(512,i13.LocationStrategy,i13.HashLocationStrategy,[i13.PlatformLocation,
              [2,i13.APP_BASE_HREF]]),i0.ɵmpd(512,i13.Location,i13.Location,[i13.LocationStrategy]),
          i0.ɵmpd(512,i0.Compiler,i0.Compiler,([] as any[])),i0.ɵmpd(512,i0.NgModuleFactoryLoader,
              i0.SystemJsNgModuleLoader,[i0.Compiler,[2,i0.SystemJsNgModuleLoaderConfig]]),
          i0.ɵmpd(1024,i22.ROUTES,() => {
            return [[{path:'home',component:i25.HomeComponent},{path:'errors',component:i26.ErrorsComponent},
                {path:'about-us',component:i27.AboutUsComponent},{path:'services',
                    component:i28.ServicesComponent,children:[{path:'automation',component:i29.AutomationComponent},
                        {path:'programming',component:i30.ProgrammingComponent},{path:'engineering',
                            component:i31.EngineeringComponent}]},{path:'contact-us',
                    component:i32.ContactUsComponent},{path:'',redirectTo:'/home',
                    pathMatch:'full'},{path:'**',redirectTo:'/errors'}]];
          },([] as any[])),i0.ɵmpd(256,i22.ROUTER_CONFIGURATION,{useHash:true},([] as any[])),
          i0.ɵmpd(1024,i22.Router,i22.ɵe,[i0.ApplicationRef,i22.UrlSerializer,i22.ChildrenOutletContexts,
              i13.Location,i0.Injector,i0.NgModuleFactoryLoader,i0.Compiler,i22.ROUTES,
              i22.ROUTER_CONFIGURATION,[2,i22.UrlHandlingStrategy],[2,i22.RouteReuseStrategy]]),
          i0.ɵmpd(512,i22.RouterModule,i22.RouterModule,[[2,i22.ɵa],[2,i22.Router]]),
          i0.ɵmpd(512,i1.KatisoModule,i1.KatisoModule,([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvWWktWXUvRG9jdW1lbnRzL0FjdHVhbCBEb2N1bWVudHMvS2F0aXNvL2thdGlzby9zcmMvYXBwL2thdGlzby5tb2R1bGUubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vQzovVXNlcnMvWWktWXUvRG9jdW1lbnRzL0FjdHVhbCBEb2N1bWVudHMvS2F0aXNvL2thdGlzby9zcmMvYXBwL2thdGlzby5tb2R1bGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// C:/Users/Yi-Yu/Documents/Actual Documents/Katiso/katiso/src/$$_gendir/app/katiso.module.ngfactory.ts